import api from './api.js';
import { Header } from './scripts/header/header';

api.Header = Header;

export default api;
